export interface IWorkgroupTimeZoneData {
    CurrentUtcOffset: string;
    IsCurrentlyDst: boolean;
    SupportsDst: boolean,
    TimeZoneName: string,
    TimeZoneIana: string
}
